<template>
  <privacy class="privacy"></privacy>
</template>
<script>
import { Privacy } from "@/components";
export default {
  components: { Privacy },
  data() {
    return {};
  }
};
</script>
<style lang="scss">
.privacy {
  padding: 20px;
  background-color: #ddd;
}
</style>
